import template from '../../../../views/statistic/partials/subscriber-list.html';

export default class subscriberList {
    constructor() {
        return {
            restrict: 'E',
            scope: {
                subscribers: '=',
                status: '=',
                uniqueCounts: '=',
                settings: '=',
                pages: '=',
                dispatcherType: '=',
                initialized: '=',
                dispatcher: '=',
                disabledDispatchers: '=',
                messageType: '='
            },
            template: template,
            controller: ['$scope', '$element', '$attrs', '$state', '$stateParams', '$rootScope', '$timeout', 'Statistics', (scope, element, attrs, $state, $stateParams, $rootScope, $timeout, Statistics) => {

                $rootScope.$on('refreshSubscribers', (event, dates) => {
                    scope.subscribers = [];
                    scope.settings.startDate = dates.startDate;
                    scope.settings.endDate = dates.endDate;
                    getSubscribers();
                });
                scope.search = null;

                scope.getStatisticNameFromStatus = () => {
                    if (scope.status === 'bounced') {
                        return scope.settings.bouncedSelection + '_bounce';
                    } else if (scope.status === 'unsubscribed') {
                        return scope.settings.unsubscribedSelection === 'user' ? 'unsubscribed' : 'spam';
                    } else {
                        return scope.status;
                    }
                };

                function setPage() {
                    if (scope.initialized) {
                        scope.subscribers = [];
                        scope.settings['currentPage'] = 1;
                        getSubscribers();
                        $rootScope.$emit('statistics:updateStatistics');
                        scope.newRecount = false;
                    }
                }

                scope.goToSubscriber = (subscriberId) => {
                    $state.go('subscriber.show', { id: subscriberId });
                };

                scope.nextPage = () => {
                    scope.settings.currentPage++;
                };

                let searchTimeout;

                scope.searchByStatus = () => {
                    if (searchTimeout) {
                        $timeout.cancel(searchTimeout);
                    }

                    searchTimeout = $timeout(function () {
                        var statisticType = scope.getStatisticNameFromStatus();

                        if (! scope.search) {
                            return setPage();
                        }

                        if (scope.dispatcherType === 'abTest') {
                            Statistics.getAbTestSubscribers(
                                $stateParams.id,
                                scope.settings,
                                statisticType,
                                1,
                                scope.search
                            ).then((response) => {
                                scope.subscribers = response['data'];
                                scope.searchCount = response['count'];
                            });
                        } else {
                            Statistics.getStatisticsSubscribers(
                                $stateParams.id,
                                scope.dispatcherType,
                                scope.settings,
                                statisticType,
                                1,
                                scope.search
                            ).then((response) => {
                                scope.subscribers = response['data'];
                            });
                        }
                    }, 500);
                };

                scope.clearSearch = () => {
                    scope.search = null;
                    scope.searchByStatus();
                };

                function getSubscribers() {
                    let page = scope.settings.currentPage === 0 ? 1 : scope.settings.currentPage;
                    let status = scope.getStatisticNameFromStatus();
                    if (scope.newRecount) {
                        scope.subscribers = [];
                    }

                    if (scope.dispatcherType !== 'abTest') {
                        Statistics.getStatisticsSubscribers($stateParams.id, scope.dispatcherType, scope.settings, status, page)
                            .then((response) => {
                                angular.forEach(response.data, (subscriber) => {
                                    scope.subscribers.push(subscriber);
                                });

                                scope.perPage = response.per_page;
                                scope.pages = Math.ceil(scope.uniqueCounts[status] / scope.perPage);
                                scope.moreToLoad = scope.pages > scope.settings.currentPage;
                            });
                    } else {
                        Statistics.getAbTestSubscribers($stateParams.id, scope.settings, status, page).then((response) => {
                            angular.forEach(response.data, (subscriber) => {
                                if (scope.settings.disabledDispatchers.length) {
                                    if (!(_.indexOf(scope.settings.disabledDispatchers, subscriber.dispatcher_id) > -1)) {
                                        scope.subscribers.push(subscriber);
                                    }
                                } else {
                                    scope.subscribers.push(subscriber);
                                }
                            });

                            scope.perPage = response.per_page;
                            scope.pages = Math.ceil(scope.uniqueCounts[status] / scope.perPage);
                            scope.moreToLoad = scope.pages > scope.settings.currentPage;
                        });
                    }
                }


                scope.$on('recounted', () => {
                    scope.newRecount = true;
                    scope.settings['currentPage'] = 1;
                    getSubscribers();
                });

                scope.$watch('settings.currentPage', (newVal, oldVal) => {
                    if (newVal !== oldVal && newVal > 1) {
                        scope.newRecount = false;
                        getSubscribers();
                    }
                });

                scope.$watchGroup([
                    'settings.unsubscribedSelection',
                    'settings.bouncedSelection',
                    'settings.selection',
                    'status',
                    'initialized'
                ], () => {
                    setPage();
                });

                let dateListener = $rootScope.$on('statistic:dates:changed', () => {
                    setPage();
                });

                scope.toExport = () => {
                    if($stateParams.automationId == undefined) {
                        $state.go('statistic.export', {
                            dispatcherType: scope.dispatcherType,
                            id: $stateParams.id,
                            statistic: scope.getStatisticNameFromStatus(scope.status),
                            disabledDispatchers: scope.disabledDispatchers,
                            link: null,
                            messageType: scope.messageType ? scope.messageType : 'email',
                            startDate: moment(scope.settings.startDate).format('YYYY-MM-DD'),
                            endDate: moment(scope.settings.endDate).format('YYYY-MM-DD')
                        });
                    } else {
                        $state.go('statistic.automationexport', {
                            dispatcherType: scope.dispatcherType,
                            id: $stateParams.id,
                            automationId: $stateParams.automationId,
                            statistic: scope.getStatisticNameFromStatus(scope.status),
                            disabledDispatchers: scope.disabledDispatchers,
                            link: null,
                            messageType: scope.messageType ? scope.messageType : 'email',
                            startDate: moment(scope.settings.startDate).format('YYYY-MM-DD'),
                            endDate: moment(scope.settings.endDate).format('YYYY-MM-DD')
                        });
                    }
                };

                scope.$on('$destroy', dateListener());
            }]
        }
    }
}
